import React, { useState, useRef } from 'react';
import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';
import './AdminForms.css';

export default function AddPost() {
  const [formData, setFormData] = useState({
    display_name: '', articleTitle: '', about: '', aboutText: '',
    reference1_text: '', reference1_link: '', reference2_text: '', reference2_link: '',
  });
  const [quillValue, setQuillValue] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const quillRef = useRef(null);

  function handleChange(e) {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  function handleFileChange(e) {
    setSelectedFile(e.target.files[0]);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setSuccess(''); setLoading(true);

    const submitData = new FormData();
    Object.keys(formData).forEach((key) => submitData.append(key, formData[key]));
    const quillDelta = quillRef.current?.getEditor().getContents();
    submitData.append('about', JSON.stringify(quillDelta));
    if (selectedFile) submitData.append('articlePic', selectedFile);

    try {
      const res = await fetch('/api/newPost', { method: 'POST', body: submitData });
      const data = await res.json();
      if (data.success) {
        setSuccess('Post added successfully!');
      } else {
        setError(data.message || 'Failed to add post');
      }
    } catch (err) {
      setError('An error occurred');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="admin-form-view">
      <h1>Add a Spotlight</h1>
      {error && <div className="admin-form-error">{error}</div>}
      {success && <div className="admin-form-success">{success}</div>}

      <form onSubmit={handleSubmit} className="admin-form">
        <div className="admin-form-row">
          <div className="admin-form-field">
            <label>Display name</label>
            <input name="display_name" value={formData.display_name} onChange={handleChange} />
          </div>
          <div className="admin-form-field">
            <label>Title</label>
            <input name="articleTitle" value={formData.articleTitle} onChange={handleChange} />
          </div>
        </div>

        <div className="admin-form-field">
          <label>Post content</label>
          <ReactQuill
            ref={quillRef}
            theme="snow"
            value={quillValue}
            onChange={setQuillValue}
            style={{ height: '220px', marginBottom: '2.5rem' }}
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link', 'image', 'video'],
                ['clean'],
              ],
            }}
          />
        </div>

        <div className="admin-form-field">
          <label>Image</label>
          <input type="file" accept="image/*" onChange={handleFileChange} />
          {selectedFile && <span className="admin-form-filename">Selected: {selectedFile.name}</span>}
        </div>

        <div className="admin-form-row">
          <div className="admin-form-field">
            <label>Reference 1 text</label>
            <input name="reference1_text" value={formData.reference1_text} onChange={handleChange} />
          </div>
          <div className="admin-form-field">
            <label>Reference 1 link</label>
            <input name="reference1_link" value={formData.reference1_link} onChange={handleChange} />
          </div>
          <div className="admin-form-field">
            <label>Reference 2 text</label>
            <input name="reference2_text" value={formData.reference2_text} onChange={handleChange} />
          </div>
          <div className="admin-form-field">
            <label>Reference 2 link</label>
            <input name="reference2_link" value={formData.reference2_link} onChange={handleChange} />
          </div>
        </div>

        <button type="submit" className="mihu-btn-primary-lg admin-form-submit" disabled={loading}>
          {loading ? 'Saving…' : 'Save post'}
        </button>
      </form>
    </div>
  );
}
